import styled from 'styled-components';
import {
  ButtonTertiary,
  IconArrowRight,
} from '@spotify-internal/encore-creator-web';
import { spacer8, spacer24 } from '@spotify-internal/encore-foundation';
import { ButtonTertiaryAsLink } from '../EncoreCreatorWebHelpers';

export const CTABtnArrow = styled(IconArrowRight).attrs({
  iconSize: 16,
})`
  margin-left: ${spacer8};
`;

export const CTABtn = styled(ButtonTertiary).attrs({
  buttonSize: 'sm',
  condensed: true,
})`
  align-items: center;
  display: flex;
  padding-bottom: ${spacer24};
  padding-top: ${spacer24};
`;

export const CTABtnAsLink = styled(ButtonTertiaryAsLink).attrs({
  buttonSize: 'sm',
  condensed: true,
})`
  align-items: center;
  display: flex;
  padding-bottom: ${spacer24};
  padding-top: ${spacer24};
`;
